import { ClientInfo, LogData, LogLevel, LogLevelType, LogOptions, Orientation, SessionStatsData } from './types';

export function getClientInfo(): ClientInfo {
    return {
        user_agent: window.navigator.userAgent,
        viewport_height: window.innerHeight,
        viewport_width: window.innerWidth
    };
}

/**
 * formatSessionStats returns an object with the necessary session stats information
 *
 * @returns {{viewport_height: number, orientation: int, screen_width: number, viewport_width: number, screen_height: number, browser: string, operating_system: string, user_language: string, touch_capable: *, user_agent: string, tenant: string}}
 */
export const getSessionStats = (): SessionStatsData => {
    return {
        user_language: window.navigator.language,
        orientation: getOrientation(),
        touch_capable: getTouchCapable(),
        screen_width: window.screen.width,
        screen_height: window.screen.height,
        ...getClientInfo()
    };
};

export const getOrientation = (): Orientation => {
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
};

export const getTouchCapable = () => {
    return 'ontouchstart' in window || window.navigator.maxTouchPoints > 0;
};

/**
 * Takes the message and severity level to log and merges it with relevant stats to record
 */
export const createLogData = (level: LogLevelType, options: LogOptions): LogData => {
    const date = new Date();
    return {
        level: LogLevel[level],
        ...getClientInfo(),
        request_path: window.location.pathname,
        timestamp: date.getTime(),
        timezone: date.getTimezoneOffset(),
        message: options.message ?? '',
        stack_trace: options.stackTrace ?? ''
    };
};
